import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import clientData from "../../Data/clientData";

const images = [];

for (let i = 28; i >= 1; i--) {
  images.push(`/assets/image/clean/${i}.jpg`);
}

const GalleryArea = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [clients, setClients] = useState([]);

  useEffect(() => {
    setClients(clientData);
  }, []);

  const [activeTab, setActiveTab] = useState("Image");
  // Handle tab change
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const showPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const showNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  return (
    <Wrapper>
      <div className="space">
        <div className="container">
          <div className="title-area text-center">
            <span className="sub-title6 justify-content-center">
              <span className="shape left">
                <span className="dots"></span>
              </span>
              OUR Gallery
              <span className="shape right">
                <span className="dots"></span>
              </span>
            </span>
            <h2 className="sec-title">Explore Our Images, Videos & Clients</h2>
          </div>

          <div
            className="nav nav-tabs service-tabs"
            id="nav-tab"
            role="tablist"
          >
            <button
              className={`nav-link th-btn ${
                activeTab === "Image" ? "active" : ""
              }`}
              onClick={() => handleTabClick("Image")}
              type="button"
            >
              Images
            </button>
            <button
              className={`nav-link d-none th-btn ${
                activeTab === "Video" ? "active" : ""
              }`}
              onClick={() => handleTabClick("Video")}
              type="button"
            >
              Videos
            </button>
            <button
              className={`nav-link th-btn ${
                activeTab === "Client" ? "active" : ""
              }`}
              onClick={() => handleTabClick("Client")}
              type="button"
            >
              Clients
            </button>
          </div>

          {activeTab === "Image" && (
            <div className="row gy-4 masonary-active">
              {images.map((img, index) => (
                <div
                  className="col-12 col-sm-6 col-md-4 filter-item"
                  key={index}
                >
                  <div className="gallery-card">
                    <div className="gallery-img">
                      <img src={img} alt={`gallery ${index}`} />
                      <button
                        className="gallery-btn popup-image"
                        onClick={() => openModal(index)}
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {activeTab === "Video" && (
            <div className="row gy-4 masonary-active"></div>
          )}

          {activeTab === "Client" && (
            <div className="client-area-6">
              <div className="row gy-4">
                {clients.map((client) => (
                  <div
                    className="col-6 col-sm-4 col-md-3 col-lg-auto text-center"
                    key={client.id}
                  >
                    <Link to="" className="client-thumb style2">
                      <img src={client.imgSrc} alt={client.alt} />
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Modal */}
        {isModalOpen && (
          <div className="custom-lightbox">
            <span className="close-btn" onClick={closeModal}>
              &times;
            </span>
            <img src={images[currentIndex]} className="lightbox-img" alt="" />
            <button className="prev-btn" onClick={showPrev}>
              &#10094;
            </button>
            <button className="next-btn" onClick={showNext}>
              &#10095;
            </button>
          </div>
        )}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .gallery-card {
    width: 100%;
  }

  .gallery-img {
    width: 100%;
    height: 300px;
    position: relative;
    overflow: hidden;
    border-radius: 10px;
  }

  .gallery-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 10px;
  }

  .gallery-btn {
    position: absolute;
    right: 10px;
    background: #ff6118;
    border: none;
    color: #fff;
    font-size: 18px;
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-lightbox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }

  .lightbox-img {
    max-width: 90%;
    max-height: 90%;
    border-radius: 8px;
  }

  .close-btn {
    position: absolute;
    top: 30px;
    right: 40px;
    font-size: 40px;
    color: white;
    cursor: pointer;
  }

  .prev-btn,
  .next-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: white;
    font-size: 40px;
    background: none;
    border: none;
    cursor: pointer;
  }

  .prev-btn {
    left: 30px;
  }

  .next-btn {
    right: 30px;
  }
`;

export default GalleryArea;
